import { 
    ActivityApiFp,
    ActivityControllerGet200Response,
    CreateActivityDto, 
    DeleteActivityDto,
    EditActivityDto,
    GetActivityDto, 
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseActivityModel = ActivityControllerGet200Response;
export type GetActivityModel = GetActivityDto;
export type MutateResponseActivityModel = MessageResponseDto;
export type CreateActivityModel = CreateActivityDto;
export type UpdateActivityModel = EditActivityDto;
export type DeleteActivityModel = DeleteActivityDto;

export const apiActivityFp = ActivityApiFp(apiConfig);
export const getActivityController = apiActivityFp.activityControllerGet;
export const createActivityController = apiActivityFp.activityControllerCreate;
export const updateActivityController = apiActivityFp.activityControllerEdit;
export const deleteActivityController = apiActivityFp.activityControllerDelete;

export const QueryKeyActivity = QueryKey.Activity;